import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loginStatus: {},
    isInternalMove: false,
    lastSearchQuery: {},
    lastSearchResult: {},
    tenants: {
      names: [],
      dict: {},
      data: {}
    }
  },
  getters: {
    loginStatus(state) {
      return state.loginStatus;
    },
    isInternalMove(state) {
      return state.isInternalMove;
    },
    lastSearchQuery(state) {
      return state.lastSearchQuery;
    },
    lastSearchResult(state) {
      return state.lastSearchResult;
    },
    tenants(state) {
      return state.tenants;
    }
  },
  mutations: {
    setLoginStatus(state, payload) {
      state.loginStatus = payload.loginStatus;
    },
    setIsInternalMove(state, payload) {
      state.isInternalMove = payload.isInternalMove;
    },
    setLastSearchQuery(state, payload) {
      state.lastSearchQuery = payload.lastSearchQuery;
    },
    setLastSearchResult(state, payload) {
      state.lastSearchResult = payload.lastSearchResult;
    },
    setTenants(state, payload) {
      state.tenants.data = payload.data;
      state.tenants.dict = payload.data.reduce(function(map, obj) {
        map[obj.uuid] = obj.name;
        return map;
      }, {});
      state.tenants.names = payload.data
        .map(function(el) {
          return el.name;
        })
        .sort();
    }
  },
  actions: {
    updateLoginStatus({ commit }, loginStatus) {
      commit("setLoginStatus", { loginStatus });
    },
    updateIsInternalMove({ commit }, isInternalMove) {
      commit("setIsInternalMove", { isInternalMove });
    },
    updateLastSearchQuery({ commit }, lastSearchQuery) {
      commit("setLastSearchQuery", { lastSearchQuery });
    },
    updateLastSearchResult({ commit }, lastSearchResult) {
      commit("setLastSearchResult", { lastSearchResult });
    },
    async updateTenants({ commit }) {
      const endpointTenantUrl = "/api/accounts/admin/tenants/";
      const res = await axios.get(endpointTenantUrl);
      const data = res.data;
      commit("setTenants", { data });
    }
  }
});

export default store;
